// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Faa-z","narrowOptionButtons":"Gaa-z","noOptions":"Haa-z"};